<template>
  <div>
    <div class="payment-page">
      <div style="padding: 1rem; position: relative" v-if="show">
        <div class="moneyBox">
          <p>Amount</p>
          <p
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              align-items: baseline;
            "
          >
            <span style="font-size: 20px; margin-right: 6px">₹</span>
            <span v-show="form.orderAmount">{{ form.orderAmount }}</span>
            <van-loading
              type="spinner"
              v-show="!form.orderAmount"
              style="color: #2a50ba"
              vertical
            ></van-loading>
          </p>
        </div>

        <div class="mainBox">
          <p class="methodBox">Choose Your Payment</p>

          <div v-show="form.walletList">
            <div
              class="payBox"
              v-for="(item, index) in form.walletList"
              :key="index"
            >
              <div>
                <img
                  v-if="item.walletCode == 'paytm'"
                  class="img1"
                  src="@/assets/paytmMax.png"
                  alt=""
                />
                <img
                  v-if="item.walletCode == 'phonepe'"
                  class="img1"
                  src="@/assets/phonePe.jpg"
                  alt=""
                />

                <div class="payBoxTips">
                  <p>
                    {{ item.walletCode == 'paytm' ? 'Paytm' : item.walletCode }}
                  </p>
                </div>
              </div>
              <div class="payBtnBox" @click="payOneBtn(9, item.clickUrl)">
                <img
                  v-if="gouFlag == 'paytm'"
                  class="img1"
                  src="@/assets/gouT.png"
                  alt=""
                />
                <img
                  v-if="gouFlag != 'paytm'"
                  class="img1"
                  src="@/assets/gouF.png"
                  alt=""
                />
              </div>
            </div>
          </div>

          <!-- 下面这部分为占位模块，没有功能 -->
          <div v-show="!form.walletList" class="payBox">
            <div>
              <img class="img1" src="@/assets/paytm.png" alt="" />

              <div class="payBoxTips">
                <p>Paytm</p>
              </div>
            </div>
            <div class="payBtnBox">
              <img
                v-if="gouFlag == 'paytm'"
                class="img1"
                src="@/assets/gouT.png"
                alt=""
              />
              <img
                v-if="gouFlag != 'paytm'"
                class="img1"
                src="@/assets/gouF.png"
                alt=""
              />
            </div>
          </div>

          <div class="payBox">
            <div>
              <img class="img1" src="@/assets/sao.png" alt="" />
              <div class="payBoxTips">
                <p>QRcode</p>
              </div>
            </div>
            <!-- <div
              class="payBtn"
              @click="payOne(1)"
              :style="!QRcodeFlag ? 'background: #e7e7e7' : ''"
            >
              PAY
            </div> -->

            <div class="payBtnBox" @click="payOneBtn(1)">
              <img
                v-if="gouFlag == 'QRcode'"
                class="img1"
                src="@/assets/gouT.png"
                alt=""
              />
              <img
                v-if="gouFlag != 'QRcode'"
                class="img1"
                src="@/assets/gouF.png"
                alt=""
              />
            </div>
          </div>

          <div v-if="paymentMethodCopyUpiFlag">
            <div
              class="payBox"
              style="display: block"
              v-if="form.paymentMethodCopyUpi != 2"
            >
              <div class="payBoxMIN">
                <div>
                  <img class="img1" src="@/assets/upiMax.png" alt="" />
                  <div class="payBoxTips">
                    <p>Manual transfer</p>
                  </div>
                </div>

                <div class="payBtnBox" @click="payOneBtn(3)">
                  <img
                    v-if="gouFlag == 'Manual transfer'"
                    class="img1"
                    src="@/assets/gouT.png"
                    alt=""
                  />
                  <img
                    v-if="gouFlag != 'Manual transfer'"
                    class="img1"
                    src="@/assets/gouF.png"
                    alt=""
                  />
                </div>
              </div>
              <!-- <p class="payBoxB">
                If paying by this method, please copy and submit the UTR to us.
              </p> -->
            </div>
          </div>
        </div>

        <div class="footerBox">
          <div @click="payOne(btnNum, btnUrl)">
            Pay ₹
            {{ form.orderAmount }}
          </div>
          <div>
            <p>Payment prompt:</p>
            <p>
              Please select the payment method you need and make sure your phone
              has the corresponding wallet software installed
            </p>
          </div>
        </div>

        <van-action-sheet v-model="showOne" title=" ">
          <div class="content">
            <div v-if="showNum == 1">
              <p class="mSy" style="color: #2a50ba; font-size: 36px">
                ₹ {{ form.orderAmount }}
              </p>
              <p class="showOneTxt" style="margin-bottom: 12px">
                Tip: Please make sure your payment amount is consistent with the
                order amount, otherwise your order may fail
              </p>
              <p class="showOneTitle">1.Copy the below given UPI</p>

              <div class="showOneSearch">
                <van-field
                  style="
                    border: 0.5px solid #c5c3c3;
                    border-radius: 5px;
                    flex: 1;
                    margin-right: 6.5px;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 14px;
                  "
                  v-model="form.upiAccountHide"
                  placeholder=""
                  disabled
                />
                <div
                  class="showOneCopy"
                  @click="copyUpiId"
                  :style="
                    !copyUpiIdFlag
                      ? 'background: #e7e7e7;line-height: 44px'
                      : 'line-height: 44px'
                  "
                >
                  COPY
                </div>
              </div>

              <p class="showOneTxt">
                Tip: Don't save the UPI, get new UPI every time.
              </p>

              <p class="showOneTitle">2. Need to enter your 12 Ref No(UTR)</p>

              <div
                class="showOneSearch"
                style="border: 0.5px solid #c5c3c3; border-radius: 5px"
              >
                <!-- <div class="showOneSearchLabel">
                  <P>*</P>
                  <p style="line-height: 2.3rem">UTR</p>
                </div> -->
                <van-field
                  style="
                    flex: 1;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 14px;
                    border-radius: 5px;
                  "
                  v-model="utrValue"
                  placeholder="input UTR number"
                />
              </div>

              <p class="test1" @click="noFlase">How to Find Your UTR?</p>
              <p class="showOneTxt">
                Tip: Open your UPI wallet and complete the transfer Record your
                reference No.(UTR) after payment.
              </p>
            </div>

            <div v-if="showNum == 2">
              <div class="qrCodeImgs">
                <div>
                  <p
                    class="mSy"
                    style="margin-bottom: 10px; font-size: 36px; color: #2a50ba"
                  >
                    ₹
                    {{
                      form.firstCheckOutQrCodeReliefSwitch == 1
                        ? form.randomAmount
                        : form.orderAmount
                    }}
                  </p>
                  <p
                    class="mSy mSyTwo"
                    style="font-size: 15px; margin-bottom: 10px; color: #999999"
                    v-if="form.firstCheckOutQrCodeReliefSwitch == 1"
                  >
                    ₹ <s> {{ form.orderAmount }}</s>
                  </p>
                </div>

                <p
                  style="
                    margin-bottom: 0;
                    font-size: 14px;
                    color: #333333;
                    font-weight: bold;
                  "
                >
                  Use Mobile Scan code to pay
                </p>

                <!-- <van-image width="154pt" height="154pt" fit="fill" :src="formattedQrCode" /> -->
                <van-image
                  width="154pt"
                  height="154pt"
                  fit="fill"
                  :src="formattedQrCode"
                  style="display: block; margin: 0 auto"
                />

                <p
                  class="saveQR"
                  @click="QRCodeBtnsFun"
                  :style="!saveQRferFlag ? 'background: #e7e7e7' : ''"
                >
                  Save QRcode
                </p>
              </div>

              <div class="showOneSearchTwo">
                <div class="showOneSearchLabelNews">
                  <p>UTR</p>
                  <p>(Optional)</p>
                </div>
                <van-field
                  style="
                    flex: 1;
                    height: 44px;
                    line-height: 44px;
                    padding: 0 14px;
                    border: 0.5px solid #c5c3c3;
                    border-radius: 5px;
                    text-align: center;
                  "
                  v-model="utrValue"
                  placeholder="input UTR number"
                />
              </div>

              <p class="showOneTxt">
                Tip: Open your UPI wallet and complete the transfer Record your
                reference No.(UTR) after payment.
              </p>

              <p class="test1" @click="noFlase">How to Find Your UTR?</p>
            </div>

            <div v-if="showNum == 9">
              <div>
                <p class="mSy" style="margin-bottom: 6px; color: #2a50ba">
                  ₹
                  {{ form.randomAmount }}
                </p>
                <p class="mSy mSyTwo" style="color: #2a50ba">
                  ₹ <s> {{ form.orderAmount }}</s>
                </p>
              </div>

              <p class="payTxt">Payment via Paytm, Limited-Time Offer</p>
            </div>

            <div class="btnFun" v-if="showNum == 9" @click="payOne(9)">
              TO PAY
            </div>
            <div
              class="btnFun"
              v-if="showNum != 9"
              v-debounce="submitPayment"
              :style="!submitUTRFlag ? 'background: #e7e7e7' : ''"
            >
              Submit UTR
            </div>
          </div>
        </van-action-sheet>
      </div>

      <div v-else>
        <div class="sBox" v-if="status == 'wait'">
          <div v-if="orderStatus == ''" class="sBox">
            <div class="circle">
              <div class="dots">
                <div
                  v-for="n in 8"
                  :key="n"
                  class="dot"
                  :style="getDotStyle(n)"
                ></div>
              </div>
              <div class="countdown">
                {{ countdown }}
              </div>
            </div>
            <p
              style="
                font-family: Source Sans Variable;
                font-weight: 400;
                text-align: center;
                font-size: 15px;
                color: #333333;
              "
            >
              UTR submitted successfully and <br />
              is being confirmed
            </p>
          </div>
          <div v-if="orderStatus == 1" class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/success@2x.png')"
            />
            <p class="sp">Your payment is successful!</p>
          </div>
          <div v-else class="sBox">
            <van-image
              width="100"
              height="100"
              :src="require('../assets/时间@2x.png')"
            />
            <p class="sp">
              The payment result may be delayed,<br />
              we will process it within 10 minutes
            </p>
          </div>
        </div>
      </div>
      <div class="sBox" v-if="status == 'timeout'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">Payment timed out, please try again</p>
      </div>

      <div class="sBox" v-if="status == 'prompt'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          Payment submission is successful, please wait patiently for the
          payment result
        </p>
      </div>

      <div class="sBox" v-if="status == 'promptTwo'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/success@2x.png')"
        />
        <p class="sp">
          {{ h5PayOrderQueryMsg }}
        </p>
      </div>

      <div class="sBox" v-if="status == 'err'">
        <van-image
          width="100"
          height="100"
          :src="require('../assets/tips@2x.png')"
        />
        <p class="sp">{{ msg }}</p>
      </div>
    </div>

    <div class="dBox" v-if="dialogFlag">
      <div class="nos" @click="noFlase">X</div>
      <div>
        <p>MobiKwik</p>
        <img src="@/assets/to1.jpg" alt="" />
        <p>Freecharge</p>
        <img src="@/assets/to2.jpg" alt="" />
        <p>Gpay</p>
        <img src="@/assets/to3.jpg" alt="" />
        <p>PayTM</p>
        <img src="@/assets/to4.jpg" alt="" />
        <p>PhonePe</p>
        <img src="@/assets/to5.jpg" alt="" />
      </div>
    </div>

    <div class="loadingBox" v-if="loadingFlag">
      <div
        style="
          margin-top: 50vh;
          transform: translate(-50%, -50%);
          width: 120px;
          height: 120px;
          background: rgba(0, 0, 0, 0.8);
          border-radius: 14px;
          margin-left: 50vw;
          display: flex;
          justify-content: center;
          align-items: center;
        "
      >
        <!-- 旋转类型+文字 -->
        <van-loading type="spinner" style="color: #fff" vertical
          >loading...</van-loading
        >
      </div>
    </div>
  </div>
</template>

<script>
import {
  h5CashRegisterGetUpiV2,
  h5PayOrderQuery,
  h5CheckOutClickV2,
  h5CheckOutUtrSubmit,
  h5OrderBuriedPointCreate,
} from '@/api'
import { Button, Dialog } from 'vant'
import Vue from 'vue'
Vue.use(Button)
import { Icon } from 'vant'
Vue.use(Icon)
import { Field } from 'vant'
Vue.use(Field)
import { CountDown } from 'vant'
Vue.use(CountDown)
import { Image as VanImage } from 'vant'
Vue.use(VanImage)
import { Toast } from 'vant'
Vue.use(Toast)
import { ActionSheet } from 'vant'
Vue.use(ActionSheet)
import { Loading } from 'vant'
Vue.use(Loading)

export default {
  data() {
    return {
      time: 9999,
      status: '默认',
      upiId: '',
      headers: {
        'X-Plat-Order-Id': this.$route.query.orderId,
        'X-Sign': this.$route.query.sign, // 使用组件中的动态值
      },
      form: {},
      show: true,
      countdown: 10,
      interval: null,
      intervalStatus: null,
      orderStatus: '',

      dialogFlag: false,
      msg: '',

      showOne: false,

      utrValue: '',

      showNum: 1,

      url: '',

      statusFlag: false,

      loadingFlag: false,

      btnFlag: false,

      // 避免出现paymentMethodCopyUpi为2时候页面闪一下的情况
      paymentMethodCopyUpiFlag: false,

      QRcodeFlag: true,
      manualTransferFlag: true,
      saveQRferFlag: true,
      submitUTRFlag: true,
      copyUpiIdFlag: true,

      h5PayOrderQueryMsg: '',

      gouFlag: 'paytm',
      src: '',
      btnNum: '',
    }
  },
  methods: {
    noFlase() {
      this.showOne = false
      this.dialogFlag = !this.dialogFlag
    },

    getDotStyle(index) {
      const angle = index * 45 * (Math.PI / 180) // 每个点之间的角度
      const radius = 30 // 半径
      const x = Math.cos(angle) * radius
      const y = Math.sin(angle) * radius
      return {
        transform: `translate(${x}px, ${y}px)`,
        animation: `dot-animation 1.4s ease-in-out infinite ${index * 0.1}s`,
      }
    },
    startCountdown() {
      this.interval = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          clearInterval(this.interval)
        }
      }, 1000)
    },
    async getStatus() {
      const res = await h5PayOrderQuery(
        {
          platOrderId: this.$route.query.orderId,
        },
        {
          'X-Plat-Order-Id': this.$route.query.orderId,
          'X-Sign': this.$route.query.sign,
        }
      )

      if (res.status != 2) {
        clearInterval(this.interval)
        clearInterval(this.intervalStatus)
        this.orderStatus = res.status
      }

      // 订单失败处理
      if (res.status == 3) {
        this.show = false
        this.status = 'err'
        this.msg = 'Payment failed'
        return
      }

      // 订单成功处理
      if (res.status == 1) {
        this.show = false
        this.status = 'promptTwo'
        this.h5PayOrderQueryMsg = 'Order successful'
        return
      }

      if (res.status == 2 && this.countdown == 0) {
        this.orderStatus = 8
      }
    },
    async getInfo() {
      const res = await h5CashRegisterGetUpiV2(
        {
          platOrderId: this.$route.query.orderId,
        },
        this.headers
      )

      // 链接已经被调起
      if (res.status == 3 && this.show != false) {
        Dialog.confirm({
          title: 'prompt',
          message: 'Have you completed the payment?',
          confirmButtonText: 'Not paid yet', //取消按钮
          cancelButtonText: 'Paid', //确定按钮
        })
          .then(() => {})
          .catch(() => {
            this.show = false
            this.status = 'prompt'
          })
      }

      // 异常处理
      if (res.status == 600 || res.status == 620) {
        this.show = false
        this.status = 'err'
        this.msg = res.message
        return
      }

      this.form = res

      this.paymentMethodCopyUpiFlag = true

      this.h5OrderBuriedPointCreateFun(3)

      this.calculateTimeDifference(res.expireTime)
    },

    onFinish() {
      this.show = false
      this.status = 'timeout'
      clearInterval(this.intervalStatus)
    },

    calculateTimeDifference(params) {
      // 获取当前印度时间的 Date 对象
      const currentTime = (() => {
        const indianTimeString = new Date().toLocaleString('en-US', {
          timeZone: 'Asia/Kolkata',
        })
        return new Date(indianTimeString)
      })()

      // 订单有效时间
      const expireTime = new Date(params.replace(' ', 'T'))

      // 计算时间差，单位为毫秒
      const timeDifference = expireTime - currentTime

      // 将结果赋值给 time
      this.time = timeDifference
    },

    copyUpiId() {
      if (this.copyUpiIdFlag == false) {
        return false
      }

      this.copyUpiIdFlag = false

      h5CheckOutClickV2(
        { platOrderId: this.$route.query.orderId, payMethod: 1 },
        this.headers
      )
        .then((res) => {
          this.copyUpiIdFlag = true
          this.h5OrderBuriedPointCreateFun(14)
          this.copyToClipboard(res.upiAccount)
        })
        .catch((err) => {
          this.copyUpiIdFlag = true
          // this.show = false
          Toast.fail('Frequent requests')
        })
    },
    copyToClipboard(text) {
      // 退回到传统的复制方法
      const textArea = document.createElement('textarea')
      textArea.value = text
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand('copy')
        // console.log('复制成功')
        this.$toast.success('Replicating Success')
      } catch (err) {
        // console.error('复制失败:', err)
        this.$toast.fail('Copy failed, please try again!')
      } finally {
        document.body.removeChild(textArea)
      }
    },
    async submitPayment() {
      if (!this.utrValue) {
        Toast.fail('Please enter the UTR.')
        return
      }
      // if (this.utrValue.length < 10 || this.utrValue.length > 18) {
      //   this.$toast.fail('The length must be between 10-18 digits')
      //   return
      // }
      if (!/^\d{12}$/.test(this.utrValue)) {
        this.$toast.fail(
          'UTR format error:UTR is a 12-digit combination, please check carefully'
        )
        return
      }

      if (this.showNum == 2) {
        this.h5OrderBuriedPointCreateFun(20)
      } else {
        this.h5OrderBuriedPointCreateFun(21)
      }

      if (this.submitUTRFlag == false) {
        return false
      }

      this.submitUTRFlag = false

      h5CheckOutUtrSubmit(
        {
          platOrderId: this.$route.query.orderId,
          utr: this.utrValue,
        },
        this.headers
      )
        .then((res) => {
          this.show = false
          this.status = 'wait'
          this.startCountdown()

          this.submitUTRFlag = true
        })
        .catch((err) => {
          this.submitUTRFlag = true
          Toast.fail(err.message)
        })
    },

    payOneBtn(num, url) {
      if (num == 9) {
        this.gouFlag = 'paytm'
      } else if (num == 1) {
        this.gouFlag = 'QRcode'
      } else if (num == 3) {
        this.gouFlag = 'Manual transfer'
      }

      this.btnNum = num
      this.btnUrl = url
    },

    payOne(num, url) {
      this.utrValue = ''
      if (!this.btnFlag) {
        return false
      }

      if (num != 3) {
        h5CheckOutClickV2(
          {
            platOrderId: this.$route.query.orderId,
            payMethod: num == 1 ? 2 : num == 9 ? 3 : 1,
          },
          this.headers
        ).then((res) => {
          // if (res.status == 200) {
          // if (num == 1) {
          //   this.showNum = 2
          //   this.showOne = true
          // } else {
          //   if (num == 2) {
          //     this.showNum = 9
          //     this.showOne = true
          //   }
          // }
          // }
        })
      }

      if (url) {
        this.url = url
      }
      if (num == 9) {
        this.h5OrderBuriedPointCreateFun(10)
        // 记录当前时间
        const startTime = Date.now()
        window.open(this.url, '_blank')
        this.loadingFlag = true
        // 设置超时检测（移动端通常在1000ms内会跳转成功）
        setTimeout(() => {
          // 如果500ms后页面仍然存在，则认为跳转失败
          this.loadingFlag = false
          if (Date.now() - startTime > 1000 && !document.hidden) {
            // alert('Failed, APP not installed')
            // Dialog.confirm({
            //   message: 'Failed, APP not installed',
            //   confirmButtonText: 'Yes',
            //   showCancelButton: false,
            // }).then(() => {
            //   // 点击确定时执行
            //   console.log('确认操作')
            // })
          }
        }, 1000)
        return
      }
      if (num == 3) {
        this.h5OrderBuriedPointCreateFun(13)
        this.showNum = 1
        this.showOne = true
        this.manualTransferFlag = false
      } else {
        if (num == 1) {
          this.h5OrderBuriedPointCreateFun(11)
          this.showNum = 2
          this.showOne = true
          this.QRcodeFlag = false
        } else {
          if (num == 2) {
            this.showNum = 9
            this.showOne = true
          }
        }
      }
    },

    setRootFontSize() {
      const baseSize = 16 // 基准字体大小
      const scale = document.documentElement.clientWidth / 375 // 375 为设计稿宽度
      document.documentElement.style.fontSize =
        baseSize * Math.min(scale, 2) + 'px' // 限制缩放倍数
    },

    // 保存图片
    QRCodeBtnsFun() {
      this.payOne(10)
      const image = new Image()
      image.crossOrigin = 'Anonymous' // 允许跨域
      image.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0)

        canvas.toBlob((blob) => {
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'saved_image.jpg' // 设置下载的文件名
          link.click()

          // 释放内存
          URL.revokeObjectURL(link.href)
        }, 'image/jpeg')
      }
      image.src = this.formattedQrCode

      this.h5OrderBuriedPointCreateFun(12)
    },

    h5OrderBuriedPointCreateFun(num) {
      if (num == 3) {
        this.btnFlag = true
      }

      if (num == 11 && this.QRcodeFlag == false) {
        return false
      } else if (num == 13 && this.manualTransferFlag == false) {
        return false
      } else if (num == 12 && this.saveQRferFlag == false) {
        return false
      }

      h5OrderBuriedPointCreate(
        {
          platOrderId: this.$route.query.orderId,
          operationType: num,
        },
        this.headers
      ).then((res) => {
        // console.log(res, num)

        if (num == 11) {
          // 点击qrcode弹框打开按钮时候
          this.QRcodeFlag = true
        } else if (num == 13) {
          // 点击Manual Transfer弹框打开按钮时候
          this.manualTransferFlag = true
        } else if (num == 12) {
          // 点击保存二维码按钮时候
          this.saveQRferFlag = true
        }
      })
    },
  },
  computed: {
    formattedQrCode() {
      // 动态拼接前缀
      return `data:image/png;base64,${this.form.qrCode}`
    },
  },
  created() {
    this.h5OrderBuriedPointCreateFun(2)
  },
  mounted() {
    this.getInfo()
    this.intervalStatus = setInterval(() => {
      this.getStatus()
      if (this.countdown <= 0) {
        clearInterval(this.intervalStatus)
      }
    }, 3000)

    this.setRootFontSize()

    window.addEventListener('resize', this.setRootFontSize)
  },
  beforeDestroy() {
    var _this = this

    // 结束时候调取的，但无法正常实现
    window.addEventListener('beforeunload', () => {
      _this.h5OrderBuriedPointCreateFun(30)
    })

    window.removeEventListener('resize', _this.setRootFontSize)
  },

  destroyed() {},
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.payment-page {
  min-height: 100vh;
  background: #fff;
}

.moneyBox {
  width: 100%;
  text-align: center;
  background: #2243f5;
  position: absolute;
  left: 0;
  top: 0;
}
.moneyBox p:nth-child(1) {
  font-size: 12pt;
  color: #fff;
  margin-bottom: 10px;
  margin-top: 30px;
  font-weight: bold;
}

.moneyBox p:nth-child(2) {
  font-size: 26pt;
  color: #fff;
  margin-bottom: 60px;
  font-weight: bold;
}

.payBox {
  display: flex;
  justify-content: space-between;
  padding: 11px 14px;
  font-size: 14px;
  border-radius: 5px;
  margin-bottom: 10px;
  align-items: center;
}

.payBoxMIN {
  display: flex;
  justify-content: space-between;
}

.payBox div {
  display: flex;
  align-items: center;
}

.img1 {
  width: 30px;
  height: 30px;
  margin-right: 9px;
}
.img2 {
  width: 12px;
  height: 12px;
  margin-left: 5px;
  margin-right: 2px;
}

.toS {
  height: 12px;
}

.payBtn {
  width: 60px;
  height: 24px;
  font-size: 0.625rem;
  background: #2a50ba;
  border-radius: 12px;
  color: #fff;
  text-align: center;
  line-height: 24px;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
}

.txtBox1 {
  margin-top: 24pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
  color: #fc4877;
}

.txtBox2 {
  margin-top: 14pt;
  padding: 23pt 12pt 20pt;
  font-size: 14px;
  border: 1px solid #c5c3c3;
  border-radius: 8pt;
  line-height: 26px;
}

.content {
  padding: 2rem 26px 60px;
}

.showOneTitle {
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: bold;
}

.showOneSearch {
  display: flex;
  margin-bottom: 1rem;
}

.showOneCopy {
  width: 4rem;
  background: #2a50ba;
  text-align: center;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  border-radius: 5px;
}

.showOneTxt {
  font-size: 12px;
  color: #ff9b00 !important;
  margin-top: 12px;
  margin-bottom: 1.3rem;
  line-height: 16px;
  font-style: italic;
}

.showOneSearchLabel {
  display: flex;
}

.showOneSearchLabel p:nth-child(1) {
  color: #ff0000;
  margin-top: 6.5px;
  margin-left: 6.5px;
}
.showOneSearchLabel p:nth-child(2) {
  font-size: 1rem;
  margin-left: 4px;
}

.btnFun {
  width: 100%;
  background: #2a50ba;
  margin: 20px auto 0;
  height: 44px;
  line-height: 44px;
  color: #fff;
  font-size: 1rem;
  text-align: center;
  border-radius: 1.4rem;
  font-weight: bold;
}

.qrCodeImgs {
  text-align: center;
}

.qrCodeImgs p {
  font-size: 1rem;
  margin-bottom: 14px;
}

.sBox {
  height: 95vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.sp {
  margin-top: 20px;
  font-family: Source Sans Variable;
  font-weight: 600;
  font-size: 15px;
  color: #333333;
}
.circle {
  position: relative;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dots {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: rotate 2.4s infinite linear;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  border-radius: 50%;
  position: absolute;
}

.countdown {
  position: absolute;
  font-size: 24px;
  color: red;
  font-weight: bold;
}

@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dot-animation {
  0% {
    opacity: 0.3;
    transform: scale(0.7);
  }
  50% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0.3;
    transform: scale(0.7);
  }
}

.qcBox {
  border: 1px solid #cacaca;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  padding: 24px 0;
  margin-bottom: 22px;
}

.qcBox img {
  width: 175px;
}

.QRCodeBtns {
  width: 145px;
  height: 29px;
  text-align: center;
  line-height: 29px;
  border: 1px solid #cacaca;
  border-radius: 3px;
  margin: auto;
  color: #333333;
  margin-top: 20px;
  font-size: 12px;
}

.payBoxB {
  margin-top: 9px;
  color: #ff9b00 !important;
  line-height: 16px;
  font-size: 10px !important;
}
.btnBox div {
  width: 100%;
  height: 44px;
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
  margin-bottom: 10px;
}
.btnBox div:nth-child(1) {
  text-align: left;
  padding-left: 20px;
  border-radius: 10px;
  background: #f3f3f6;
  color: #a1a1a1;
  margin-bottom: 30px;
}
.btnBox div:nth-child(2) {
  color: #f3f3f6;
  background: #2a50ba;
  font-weight: bold;
}

.txtBoxMax {
  font-size: 12px;
  margin-top: 22px;
  font-weight: bold;
}

.txtBoxMax div {
  display: flex;
}
.txtBoxMax div p {
  line-height: 20px;
  color: #333333;
  margin-bottom: 10px;
}

.txtBoxMax div p:nth-child(1) {
  margin-right: 4px;
}

.dBox {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  padding: 20pt;
  width: 100vw; /* 固定宽度 */
  height: 100vh; /* 固定高度 */
  overflow: auto; /* 自动显示滚动条 */
  z-index: 999999999999999999999999999999999999999999999999999999;
}

.dBox img {
  width: 100%;
}

.nos {
  position: fixed;
  top: 0;
  right: 0;
  width: 36pt;
  height: 36pt;
  border-radius: 18pt;
  text-align: center;
  line-height: 40pt;
  background: #fff;
  font-size: 22px;
}

.dBox p {
  margin: 20px 0;
  font-size: 22px;
}

.mSy {
  text-align: center;
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: bold;
}

.mSyTwo {
  font-size: 16px;
  display: block;
  text-align: center;
}

.payTxt {
  background: #f4f9fe;
  color: #5593f3;
  padding: 14px 20px;
  width: 100%;
  margin-bottom: 28px;
}

.test1 {
  color: #da2f2f;
  margin-bottom: 12px;
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
}

.saveQR {
  display: inline-block;
  color: #2a50ba;
  border: 1px solid #2a50ba;
  border-radius: 15px;
  padding: 0px 25px;
  font-size: 12px !important;
  height: 29px;
  line-height: 29px;
}

.mainBox {
  background: #fff;
  border-radius: 10px;
  padding: 26px 18px 26px;
  position: relative;
  z-index: 10;
  margin-top: 85px;
}

.methodBox {
  color: #000;
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 6px;
}

.payBoxTips {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start !important;
}

.payBoxTips p:nth-child(1) {
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  transform: translateY(-3px);
}
.payBoxTips p:nth-child(2) {
  color: #999999;
  font-size: 9px;
  transform: translateY(3px);
}

.payBtnBox {
  display: flex !important;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end !important;
}

.payBtnBox p {
  color: #2a50ba;

  font-size: 0.625rem;
}
.payBtnBox span {
  font-weight: bold;
}

.showOneSearchLabelNews {
  display: flex;
  margin-bottom: 12px;
}
.showOneSearchLabelNews p:nth-child(1) {
  font-size: 14px;
  font-weight: bold;
  margin-right: 2px;
}
.showOneSearchLabelNews p:nth-child(2) {
  font-size: 12px;
}

.showOneSearchTwo /deep/.van-field__control,
.showOneSearch /deep/.van-field__control {
  font-size: 16px;
  text-align: center;
}

.loadingBox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  background: rgba(#ccc, #ccc, #ccc, 0.8);
  top: 0;
  left: 0;
}

.dNone {
  display: none !important;
}

.footerBox {
  position: fixed;
  bottom: 20px;
  left: 0;
  width: 100vw;
  background: #fff;
  padding: 10px 20px;
}

.footerBox div:nth-child(1) {
  width: 90%;
  background: #2145f5;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  height: 40px;
  line-height: 40px;
  border-radius: 10px;
  font-size: 16px;
}

.footerBox div:nth-child(2) p:nth-child(1) {
  margin-top: 16px;
  font-size: 14px;
}
.footerBox div:nth-child(2) p:nth-child(2) {
  font-size: 14px;
  color: #999 !important;
  line-height: 14px;
}
</style>
